// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__f35uN","fileBtn":"File_fileBtn__2e5e3","closeBtn":"File_closeBtn__2L2Jv","fileSelected":"File_fileSelected__3RS2z","disabled":"File_disabled__3ppvM"};